import * as requests from "../../coraWebComponents/utils/requests";
import { strToDate } from '../../coraWebComponents/utils/convert';
import urls from "../../constants/Urls";
import saveAs from "file-saver";

const buildFaktura = (id = "") => {
  return `${urls.Faktury}/${id}`;
};

export const getFaktura = async (id) => {
  if (id === 0) {
    return null;
  }

  const url = buildFaktura(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getFakturaPDF = async (id, fileName) => {
  if (id === 0) {
    return null;
  }

  try {
    let res = await requests.getBlob(`${urls.FakturaPDF}/${id}`);
    saveAs(res, fileName);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListFaktura = async (filter, sort, page) => {
  const url = buildFaktura();
  try {
    let res = await requests.getList(url, filter, sort, page);
    res.Data.Items.forEach((item) => {
      item.D_VYSTAVENIA = strToDate(item.D_VYSTAVENIA);
      item.D_SPLATNOSTI = strToDate(item.D_SPLATNOSTI);
      item.D_OBD_OD = strToDate(item.D_OBD_OD);
      item.D_OBD_DO = strToDate(item.D_OBD_DO);
    });
    return res;
  } catch (error) {
    throw error;
  }
};
